import ObjectCreateUpdateDialog from "./ObjectCreateUpdateDialog";

function ObjectParentDialog(props) {
  return <ObjectCreateUpdateDialog {...props} />;
}

export default ObjectParentDialog;
